
import {throwError as observableThrowError} from 'rxjs';
import { Injectable } from '@angular/core';
@Injectable()
export class CommonService {
    constructor() { }
    _errorHandler(error: Response) {
        return observableThrowError(error || 'Server Error on Server Occured');
    }

}
